export default __webpack_public_path__ + "static/media/axel.56939a02.png";